import { ref, onMounted, onUnmounted } from 'vue'

// 设置移动端设备（包含平板）屏幕宽度阈值
const MOBILE_WIDTH_THRESHOLD = 1024

// 自定义 Hook 用于判断是否为移动端
export function useIsMobile() {
  const isMobile = ref<boolean>(false)

  // 根据 userAgent 判断是否为移动端
  const checkUserAgent = (): boolean => {
    const ua = navigator.userAgent.toLowerCase()
    return /iphone|ipad|ipod|android|blackberry|windows phone/.test(ua)
  }

  // 根据屏幕宽度判断是否为移动端
  const checkScreenWidth = (width: number): boolean => {
    return width < MOBILE_WIDTH_THRESHOLD
  }

  // 初始化时检查设备类型
  const updateIsMobile = (): void => {
    const userAgentMatch = checkUserAgent()
    const screenWidthMatch = checkScreenWidth(window.innerWidth)
    isMobile.value = userAgentMatch || screenWidthMatch
  }

  // 使用 ResizeObserver 监听窗口大小变化
  const resizeObserver = new ResizeObserver(() => {
    updateIsMobile()
  })

  // 在组件挂载时立即检查并开始监听
  onMounted(() => {
    updateIsMobile()
    resizeObserver.observe(document.documentElement)
  })

  // 在组件卸载时移除监听器
  onUnmounted(() => {
    resizeObserver.disconnect()
  })

  // 返回当前是否为移动端的值
  return isMobile
}
